module.exports = __webpack_public_path__ + "assets/img/e-b-n-1.14f51907.png";